import { render, staticRenderFns } from "./workflow-selector.vue?vue&type=template&id=92bd94f8"
import script from "./workflow-selector.vue?vue&type=script&lang=js"
export * from "./workflow-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports